/* global console, define */
define('casino/mycasino',['jquery', 'casino/casino', 'all/navigation', 'all/slidingContentWrapper', 'all/dialog', 'all/player/session', 'all/template'], function($, casino, navigation, slidingContentWrapper, dialog, session) {
	'use strict';

	var lovedGameIds = [];

	function populateMyCasinoGamesArea(id, gameIds, gamesPerPage) {
		var $area = $(id);
		if (gameIds.length > 0) {
			$area.populate(gameIds, {gamesPerPage: gamesPerPage});
			$area.find('article p').hide();
			$area.find('.area:last').show();
		} else {
			$area.find('article p').show();
			$area.find('.area:last').hide();
		}
		$area.scroller({direction: 'left', auto: false});
	}

	function populateMyCasinoBiggestWins(wins) {
		var $biggestWins = $('#biggest-wins');
		if (wins.length !== 0) {
			$biggestWins.find('ul').show();
			$biggestWins.find('div:first').hide();

			var $biggestWinTemplate = $biggestWins.find('li').first();
			var $biggestWinsListHolder = $biggestWins.find('ul');
			$biggestWinsListHolder.show();
			$biggestWinsListHolder.empty();

			$.each(wins, function(item, biggestWin) {
				var $newBiggestWin = $biggestWinTemplate.clone();
				var $game = casino.getGames([biggestWin.gameId])[0];
				if ($game !== undefined) {
					$newBiggestWin.click(function() {
						window.location = '#!' + $game.id;
					});
					$newBiggestWin.find('img').attr('src', navigation.dynamicURL($game.icon));
					$newBiggestWin.find('strong').text(biggestWin.amount);
					$newBiggestWin.find('a').text($game.name).attr('href', '#!' + $game.id);
					$newBiggestWin.find('time').text(biggestWin.time);
					$biggestWinsListHolder.append($newBiggestWin);
				}
			});
		} else {
			$biggestWins.find('div').show();
			$biggestWins.find('ul').hide();
		}
	}

	function hasLove(gameId) {
		return $.inArray(gameId, lovedGameIds) !== -1;
	}

	function setupRegisterLoginButtons() {
		var  $myCasino = $('#casino-mycasino');
		$myCasino.find('a.register').off('click').on('click', slidingContentWrapper.showSlidingSignup);
		$myCasino.find('a.login').off('click').on('click', function(){
			slidingContentWrapper.showSlidingLoginPopup();
		});
	}

	function clearMyCasino() {
		populateMyCasinoGamesArea('#recently-played-games', [], 4);
		populateMyCasinoGamesArea('#most-played-games', [], 8);
		populateMyCasinoGamesArea('#loved-games', []);
		populateMyCasinoBiggestWins([]);
	}

	function populateMyCasinoWithData(data) {
		populateMyCasinoGamesArea('#recently-played-games', data.recentlyPlayedGameIds, 4);
		populateMyCasinoGamesArea('#most-played-games', data.mostPlayedGameIds, 8);
		populateMyCasinoGamesArea('#loved-games', data.lovedGameIds);
		populateMyCasinoBiggestWins(data.biggestWins);
	}

	function populateMyCasino() {
		$.ajax('/pp?flow=MyCasinoJson')
			.done(function(data) {
				if(data.ERROR && data.ERROR.length > 0) {
					console.log('Error fetching MyCasinoJson:', data.ERROR, data);
					clearMyCasino();
				} else {
					lovedGameIds = data.lovedGameIds;
					populateMyCasinoWithData(data);
				}
			})
			.fail(function() {
				clearMyCasino();
			});
	}

	function showHideContent(authenticated) {
		var $myCasino = $('#casino-mycasino');

		var template = authenticated ? 'logged-in' : 'logged-out';
		$myCasino.find('.cnt-page-header .inner').applyTemplate(undefined, {template: template});
		$myCasino.find('.leftcolumn,.rightcolumn').toggle(session.authenticated);
	}

	function update() {
		showHideContent(session.authenticated);
		if(session.authenticated) {
			populateMyCasino();
		} else {
			clearMyCasino();
			setupRegisterLoginButtons();
		}
	}

	function onload() {
		$(session).on('login logout', update);
	}

	var mycasino = {
		update: update,
		hasLove: hasLove
	};

	$(onload);

	return mycasino;
});

